import { render, staticRenderFns } from "./SectionBilan.vue?vue&type=template&id=79e5c422&scoped=true"
import script from "./SectionBilan.vue?vue&type=script&lang=js"
export * from "./SectionBilan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79e5c422",
  null
  
)

export default component.exports